import { render, staticRenderFns } from "./Dob.vue?vue&type=template&id=fd794e44&scoped=true"
import script from "./Dob.vue?vue&type=script&lang=ts"
export * from "./Dob.vue?vue&type=script&lang=ts"
import style0 from "./Dob.vue?vue&type=style&index=0&id=fd794e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd794e44",
  null
  
)

export default component.exports